export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: "爆料在线的「独家猛料」和其他平台有什么不同？",
    a: "我们坚持先核实后发布。每条独家属内容都会标注信息来源类型与时间线节点，若后续出现新的反证，我们会在原文顶部公开更新，而不是悄悄删稿。独家对我们来说是「先于全网且经得起追问」，而不是「抢先发言」。",
  },
  {
    q: "内幕调查一般需要多久才能完成？",
    a: "视线索复杂度而定，通常在两到六周之间。我们要求每篇调查至少交叉验证三个独立信源，并对关键时间点做可比对的外部信息还原。周期偏长是刻意的，因为急于成稿正是传闻最容易失真的地方。",
  },
  {
    q: "「微八卦」是不是纯粹的主观猜测？",
    a: "不是。微八卦栏目只做「已公开素材的细节解读」，例如公开播出的片段、官方发布的海报、公开采访中的表述。我们不会对未公开的私人生活作判断，也会在文中明确区分事实描述与主观推测。",
  },
  {
    q: "如果我发现某篇爆料的内容有误，应该怎么反馈？",
    a: "欢迎通过页面底部的联系方式把具体信息发给我们，请尽量附上可核对的依据。核实后我们会更正或补充说明，并保留修改记录。我们不接受仅凭立场的删除请求，但会认真对待每一条事实层面的质疑。",
  },
  {
    q: "首发快讯和深度长文应该怎么选着看？",
    a: "如果你只想快速知道「发生了什么」，看首发快讯就够了；如果你想理解「为什么会变成这样」，深度长文会更合适。两者常常配套出现——快讯负责时效，长文负责把前因后果讲清楚。",
  },
  {
    q: "订阅邮件后多久能收到一次内容？",
    a: "通常每周两到三次，只推送我们认为值得占用你时间的独家或调查内容，不会把所有更新都发一遍。你随时可以通过邮件底部的链接退订，不需要说明理由。",
  },
];